import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getAdmins,
  getAdminByID,
  createAdmin,
  editAdmin,
  deleteAdmin,
  deleteCurrentAdmin,
} from '../../store/actions/admins/admins.action';

import PageLoader from '../../components/Common/PageLoader';
import AdminsList from '../../components/Admins/AdminsList';

const AdminsContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const admins = useSelector((state) => state.admin.admins);
  const isFetching = useSelector((state) => state.admin.isFetching);
  const isCreating = useSelector((state) => state.admin.isCreating);
  const currentAdmin = useSelector((state) => state.admin.currentAdmin);

  // Action handlers
  const handleGetAdminByID = useCallback((adminId) => {
    return dispatch(getAdminByID(adminId));
  }, [dispatch]);

  const handleCreateAdmin = useCallback((adminData) => {
    return dispatch(createAdmin(adminData));
  }, [dispatch]);

  const handleEditAdmin = useCallback((adminData) => {
    return dispatch(editAdmin(adminData));
  }, [dispatch]);

  const handleDeleteAdmin = useCallback((admin) => {
    return dispatch(deleteAdmin(admin));
  }, [dispatch]);

  const handleDeleteCurrentAdmin = useCallback((admin) => {
    return dispatch(deleteCurrentAdmin(admin));
  }, [dispatch]);

  // Fetch admins on mount
  useEffect(() => {
    dispatch(getAdmins());
  }, [dispatch]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Prepare actions object for child component
  const adminsAction = {
    getAdminByID: handleGetAdminByID,
    createAdmin: handleCreateAdmin,
    editAdmin: handleEditAdmin,
    deleteAdmin: handleDeleteAdmin,
    deleteCurrentAdmin: handleDeleteCurrentAdmin,
  };

  return (
    <section className="admins-list">
      <AdminsList
        admins={admins}
        adminsAction={adminsAction}
      />
    </section>
  );
};

export default AdminsContainer;
